import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GlobalUserManagement = () => {
  const userStats = [
    { role: 'Members', count: 11847, icon: 'Users', color: 'var(--color-primary)', change: '+847' },
    { role: 'Trainers', count: 342, icon: 'Dumbbell', color: 'var(--color-accent)', change: '+12' },
    { role: 'Staff', count: 487, icon: 'UserCheck', color: 'var(--color-info)', change: '+23' },
    { role: 'Managers', count: 94, icon: 'Briefcase', color: 'var(--color-warning)', change: '+5' },
    { role: 'Owners', count: 47, icon: 'Crown', color: 'var(--color-success)', change: '+3' },
    { role: 'Sysadmins', count: 3, icon: 'Shield', color: 'var(--color-error)', change: '0' }
  ];

  const recentActivity = [
    { action: 'New gym registered', gym: 'TrainaryGym Miami', time: '2 hours ago', icon: 'Building2', color: 'var(--color-success)' },
    { action: 'Subscription upgraded', gym: 'TrainaryGym Boston', time: '5 hours ago', icon: 'TrendingUp', color: 'var(--color-primary)' },
    { action: 'Support ticket resolved', gym: 'TrainaryGym Seattle', time: '8 hours ago', icon: 'CheckCircle', color: 'var(--color-info)' },
    { action: 'Payment failed', gym: 'TrainaryGym Denver', time: '12 hours ago', icon: 'AlertCircle', color: 'var(--color-warning)' }
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Global User Management
          </h3>
          <p className="text-sm text-muted-foreground">
            Platform-wide user statistics and activity
          </p>
        </div>
        <Button variant="outline" size="sm">
          <Icon name="Settings" size={16} className="mr-2" />
          Manage Roles
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
        {userStats?.map((stat, index) => (
          <div key={index} className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${stat?.color}15` }}
              >
                <Icon name={stat?.icon} size={16} color={stat?.color} />
              </div>
              <span className="text-xs font-medium text-success">{stat?.change}</span>
            </div>
            <p className="text-2xl font-heading font-semibold text-foreground mb-1">
              {stat?.count?.toLocaleString()}
            </p>
            <p className="text-xs text-muted-foreground">{stat?.role}</p>
          </div>
        ))}
      </div>

      <div>
        <h4 className="text-sm font-medium text-foreground mb-4">Recent Platform Activity</h4>
        <div className="space-y-3">
          {recentActivity?.map((activity, index) => (
            <div key={index} className="flex items-center gap-4 p-3 bg-muted/30 rounded-lg">
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${activity?.color}15` }}
              >
                <Icon name={activity?.icon} size={18} color={activity?.color} />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground">{activity?.action}</p>
                <p className="text-xs text-muted-foreground">{activity?.gym}</p>
              </div>
              <span className="text-xs text-muted-foreground whitespace-nowrap">{activity?.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GlobalUserManagement;